import React, { useState, createContext } from 'react';

export const SideNavbarContext = createContext();

export const SideNavbarProvider = ({ children }) => {
  const [selected, setSelected] = useState('');

  const value = {
    selected,
    setSelected,
  };

  return <SideNavbarContext.Provider value={value}>{children}</SideNavbarContext.Provider>;
};
